/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetRolesQuery, RolesSortInput } from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort: RolesSortInput;
};

export function useGetRoles({ page, limit, sort }: Props) {
  const { data, loading, error } = useGetRolesQuery({
    variables: { page: Number(page), limit: Number(limit), sort },
  });

  const count = data?.roles.pageInfo?.count ?? 0;

  return { data: data?.roles.result ?? [], loading, error, count } as const;
}
